import client from '@/api/client'
import { ScorecardEntity } from '@/entities/scorecard'
import { ToggleStarred } from '@/entities/topicfeedback'
import { OfflineCache } from '@/mobile/src/utils/offlinecache'
import { IScorecardTopic } from '@/pages/appstore/components/Scorecard/scorecard-settings-entity'

const offlineCache = new OfflineCache('scorecard')

export interface BadgeFilter {
    badgeDateRange: Array<number>
}

export async function getScorecard(userId?: string, badgeDateRange?: BadgeFilter) {

    let filters = {}

    /* Dear Developer,
    Re WEB-9572/3
    The filter does not have all the information for the mobile app at the time of writing.
    So for the moment we are not apply filter unless it is the Desktop.  Future items will likely change this.
     */

    if (badgeDateRange && process.env.CONFIG_KEY !== 'mobile') {
        const f = {'badge-date-range': [ badgeDateRange.badgeDateRange[0], badgeDateRange.badgeDateRange[1] ]}
        filters = { params: { filters: f } }
    }
    return offlineCache.cachedGet<ScorecardEntity>(client, `/scorecard` + (userId ? `/user/${userId}` : ``) ,undefined, filters)
}

export async function getScorecardTopics() {
    return await client.get<IScorecardTopic>(`/scorecard-settings/topics`)
}

export async function getMyTeam() {
    return offlineCache.cachedGet(client, `/scorecard/my-team`)
}

export async function getBadgeTotalCount(badge: string, type: string, userId?: string) {
    badge = encodeURIComponent(badge)
    const t = type === 'positive' ? 1 : -1
    return offlineCache.cachedGet(client, `/scorecard/badge/`+ (userId ? `user/${userId}/` : ``) + `${t}/${badge}/total`)
}

export async function seeBadge(badge: string, type: string) {
    badge = encodeURIComponent(badge)
    const t = type === 'positive' ? 1 : -1
    return client.post(`/scorecard/badge/${t}/${badge}/see`, {})
}

export async function finishTour() {
    return client.post(`/scorecard/finish-tour`, {})
}

export async function loadScorecardStats(weekNumberBefore: number) {
    return client.get(`/scorecard/stats/${weekNumberBefore}`)
}

export async function loadScorecardResponseRates(months: number) {
    return client.get(`/scorecard/response-rates/${months}`)
}

export async function getTopicFeedback(month: number, metric: string, sortFavouritesFirst = false) {
    return client.get(`/topicfeedback`, {
        params: {
            filters : {
                month: month,
                question_type: metric
            },
            sortFavouritesFirst: sortFavouritesFirst
        }
    })
}

export async function toggleResponseStarred(responseId: number): Promise<ToggleStarred|void> {
    const response = await client.post(`/reportcard/favourites/toggle/${responseId}`)
    const success = response.status === 200
    if (success) {
        const status = (response.data?.status === 'created')
        const data:ToggleStarred = {questionId: Number(responseId)}
        return data
    }

    throw new Error('Issue toggling favourite for :' + responseId)
}
